// Components
import ShareSocialNetwork from "./ShareSocialNetwork";
import Copyright from "./Copyright";
import MainContent from "./MainContent";

// Styles
import "../../styles/textHighlighter.css";

const Footer = () => {
  return (
    <div className="px-0 sm:px-12">
      <div className="text-left text-black">
        <ShareSocialNetwork />
        <div className="flex justify-center items-center  border-b border-gray-300" />
        <MainContent />
      </div>
      <Copyright />
    </div>
  );
};

export default Footer;
